/* eslint-disable no-underscore-dangle */
import React from 'react'

import { Form, Input, Row, Col, Button } from 'antd'

export const customAllowedDomain = {
  createEditElem: (info, reactObj, val, NineGQLUI, values) => {
    console.log(info, reactObj, val, NineGQLUI, values)

    const { attrs, inputAttrs } = NineGQLUI.getAttrs(info)

    const wrapperAttrs = {}
    if (attrs.className != null) {
      wrapperAttrs.className = attrs.className
      delete attrs.className
    }

    const updateBtn = reactObj.createUpdateBtn ? reactObj.createUpdateBtn() : null

    return (
      <Form.Item label={info.editLabel} key={info.name} {...wrapperAttrs}>
        <Row gutter={8}>
          <Col span={16}>
            <Form.Item name={info.name} {...attrs}>
              <Input placeholder={info.desc} {...inputAttrs} />
            </Form.Item>
          </Col>
          <Col span={8}>{updateBtn}</Col>
        </Row>
      </Form.Item>
    )
  },
  createDetailElem: (info, reactObj, val, NineGQLUI, values) => {
    console.log(info, reactObj, val, NineGQLUI, values)

    if (values == null) {
      return ''
    }

    const allowedDomainList = values.workspaceAllowedDomain.edges

    if (allowedDomainList.length === 0) {
      return '-'
    }

    const domainElems = allowedDomainList.map((item) => {
      return (
        <p key={item.node.id} className={info.options.styles.allowedDomain}>
          {item.node.allowedDomain}
        </p>
      )
    })

    const openDomainList = () => {
      if (reactObj.openDomainList != null) {
        reactObj.openDomainList()
      }
    }
    return (
      <Row>
        <Col span={16}>{domainElems}</Col>
        <Col span={8}>
          <Button onClick={openDomainList}>Test</Button>
        </Col>
      </Row>
    )
  },
}

export default customAllowedDomain
